<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Public Form Survey</v-card-title>
        <v-card-text> {{ text }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="$emit('restartOrCont', true)">
            {{ btnOne }}
          </v-btn>
          <v-btn color="green darken-1" text @click="$emit('restartOrCont', false, 'no')"> 
            {{ btnTwo }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  props: {
    dialog: {
      type: Boolean
    },
    text: {
      type: String
    },
    btnOne: {
      type: String
    },
    btnTwo: {
      type: String
    }
  }
}
</script>